export const prepareSnippetTemplate = (template) => template.replace(/\$(\d+)/g, "#{$1}") + "${}";

const environmentSnippet = (name) => `\\begin{${name}}
\t$1
\\end{${name}}`;

export const snippets = {
    figure: prepareSnippetTemplate(`\\begin{figure}
\t\\centering
\t\\includegraphics[width=0.5\\linewidth]{$1}
\t\\caption{\${2:Caption}}
\t\\label{\${3:fig:placeholder}}
\\end{figure}`),
    table: prepareSnippetTemplate(`\\begin{table}[$1]
\t\\centering
\t\\begin{tabular}{\${2:c|c}}
\t\t$3 & $4 \\\\
\t\t$5 & $6
\t\\end{tabular}
\t\\caption{\${7:Caption}}
\t\\label{\${8:tab:placeholder}}
\\end{table}`),
    cite: prepareSnippetTemplate("\\cite{${}}"),
    ref: prepareSnippetTemplate("\\ref{${}}"),
    itemize: prepareSnippetTemplate(`\\begin{itemize}
\t\\item $1
\\end{itemize}`),
    enumerate: prepareSnippetTemplate(`\\begin{enumerate}
\t\\item $1
\\end{enumerate}`),
    equation: prepareSnippetTemplate(environmentSnippet("equation")),
};
